export const formatMessage = (message) => {
    if (!message) return null; // Handle null or undefined messages
    const urlRegex = /(\b(?:https?|ftp):\/\/[^\s]+|\b(?:www\.)?[\w-]+(\.[a-z]{2,})(\/[^\s]*)?)/gi;
    const matches = [...message.matchAll(urlRegex)];

    if (matches.length === 0) return [message]; // No links, just return text

    const elements = [];
    let lastIndex = 0;

    for (const match of matches) {
        const start = match.index;
        const end = start + match[0].length;

        // Push the text before the link
        if (lastIndex < start) {
            elements.push(message.substring(lastIndex, start));
        }

        // Push the link
        const link = match[0];
        const href = link.startsWith('http') ? link : `http://${link}`;
        elements.push(
            <a key={start} href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#bebebe', textDecoration: 'underline' }}>
                {link}
            </a>
        );

        lastIndex = end;
    }

    // Push any remaining text after the last match
    if (lastIndex < message.length) {
        elements.push(message.substring(lastIndex));
    }

    return elements;
}